/* eslint-disable import/no-cycle */
import _ from 'lodash';
import { set, setIsLoadingLoaded, setErrorMessage, clear } from './actions';
import { initialState } from './initialState';
import {
  selectThisSlice,
	selectIsLoading,
	selectIsLoaded,
	selectErrorMessage
} from './selectors';
import { ROOT_SLICE } from './constants';


const isDefined = v => v !== undefined && v !== null;

// ************
// PARTS
// ************
const reducerParts = {
  [clear]: (state) => {
    return {
      ...state,
      [ROOT_SLICE]: _.cloneDeep(initialState)
    };
	},

  [set]: (state, { payload: { data } }) => {
    const rootSlice = selectThisSlice(state);
    
		return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        data
      }			
		};
	},

	[setIsLoadingLoaded]: (
		state,
		{ payload: { isLoading: newIsLoading, isLoaded: newIsLoaded } }
	) => {
    const rootSlice = selectThisSlice(state);
		const isLoading = selectIsLoading(state);
		const isLoaded = selectIsLoaded(state);

		const CHANGED = {
			isLoading: isDefined(newIsLoading) && newIsLoading !== isLoading,
			isLoaded: isDefined(newIsLoaded) && newIsLoaded !== isLoaded
		};

		if (!CHANGED.isLoaded && !CHANGED.isLoading) {
			return state;
		}

    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        isLoading: CHANGED.isLoading ? newIsLoading : isLoading,
        isLoaded: CHANGED.isLoaded ? newIsLoaded : isLoaded
      }			
		};
	},

	[setErrorMessage]: (
		state,
		{ payload: { errorMessage: newErrorMessage } }
	) => {
    const rootSlice = selectThisSlice(state);
    const errorMessage = selectErrorMessage(state);

		if (newErrorMessage === errorMessage) {
			return state;
		}


    return {
      ...state,
      [ROOT_SLICE]: {
        ...rootSlice,
        errorMessage: newErrorMessage
      }			
		};
  }
};

export default reducerParts;
